import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { ShieldCheck, Star, Loader2, Sparkles, Target, ShoppingBag, Lock } from 'lucide-react';

const INCLUDED = [
  { icon: Target, title: '30-point clinical analysis', desc: 'IGA, Glogau & Hayashi dermatology scales across 7 face zones' },
  { icon: Sparkles, title: 'On-photo skin mapping', desc: 'Every point marked directly on your selfie, PerfectCorp-style' },
  { icon: ShoppingBag, title: 'Matched product picks', desc: 'Targeted to YOUR detected concerns — not generic lists' },
];

const ScanPreviewModal = ({ open, onOpenChange, onConfirm, loading }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md rounded-2xl bg-white" data-testid="scan-preview-modal">
      <DialogHeader>
        <DialogTitle className="font-heading text-2xl text-[#1A1514]">Your AI Skin Scan</DialogTitle>
        <DialogDescription className="text-sm text-[#8C7A76]">
          Here's exactly what you get for <span className="font-bold text-[#FF6B4A]">$1.99</span> — no subscription, no account needed.
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-3">
        {INCLUDED.map((item) => (
          <div key={item.title} className="flex items-start gap-3 bg-[#FFF2EC] rounded-xl p-3">
            <span className="w-9 h-9 rounded-xl bg-[#FF6B4A]/12 text-[#FF6B4A] flex items-center justify-center flex-shrink-0">
              <item.icon className="w-4 h-4" />
            </span>
            <div>
              <p className="text-sm font-bold text-[#1A1514]">{item.title}</p>
              <p className="text-xs text-[#8C7A76] leading-relaxed">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-center gap-1.5" data-testid="scan-modal-rating">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#E8B93E] text-[#E8B93E]" />)}
        <span className="text-xs text-[#8C7A76] ml-1">"Found my triggers in a week" — early user</span>
      </div>

      <Button onClick={onConfirm} disabled={loading}
        className="w-full bg-[#FF6B4A] hover:bg-[#E8552F] text-white rounded-full h-12 font-bold text-base"
        data-testid="scan-modal-confirm-btn">
        {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Lock className="w-4 h-4 mr-2" /> Continue to secure checkout — $1.99</>}
      </Button>
      <p className="flex items-center justify-center gap-1.5 text-[11px] text-[#8C7A76] -mt-1">
        <ShieldCheck className="w-3.5 h-3.5 text-[#4ADE80]" /> Payments secured by Stripe · Results in under 60 seconds
      </p>
    </DialogContent>
  </Dialog>
);

export default ScanPreviewModal;
